export class ProfileModel {
    profileId: number;
    profileName: string;
    settings: SettingsModel;
    applications: Array<string>;
    appPackage: string;
    defaultProfile: boolean;
    selected?: boolean;

    constructor() {
        this.applications = [];
    }
}

export class SessionProfileModel {
    setNo: number;
    sessionProfiles: Array<ProfileModel>;

    constructor(setNo, sessionProfiles) {
        this.setNo = setNo;
        this.sessionProfiles = sessionProfiles;
    }
}

export class FanModel {
    fanId: number;
    accountStatus: string; // Active, Enrolled not active, In Progress
    accountSubStatus?: string;
    profileName: string; // ProfileModel profileId
    selected?: boolean;
    groupId?: string;
    pdpindicator?: boolean;
    addpEligibleStatus?: boolean;
}

export class AppModel {
    appId: string;
    appName: string;
    longDesc: string;
    shortDesc: string;
    default: boolean;
    selected?: boolean;
}

export class AccountsModel {
    newSetupFanList: Array<FanModel>;
    revisedFanList: Array<FanModel>;
    awaitingSignupFanList: Array<FanModel>;

    constructor() {
        this.newSetupFanList = [];
        this.revisedFanList = [];
        this.awaitingSignupFanList = [];
    }
}

export class SettingsModel {
    newDevNwt: boolean;
    extDevNwt: boolean;
    securityPolicy: string;
    passCodePolicy: string;
    emailEnabled: boolean;
    smsEnabled: boolean;
}


export class EnrollmentDateModel {
    new: Date;
    existing: Date;

    constructor() {
        this.new = new Date();
    }
}

export class EnrollmentCheckboxModel{
    checked: boolean;
    disabled: boolean;
    constructor(){
        this.checked = true;
        this.disabled = false;
    }
}

export class SignupSetupModel {
    companyId: number;
    FANList: AccountsModel;

    constructor(companyId) {
        this.FANList = new AccountsModel();
        this.companyId = companyId;
    }
}

export class SignupSetupInputModel extends SignupSetupModel {
    profileList: Array<ProfileModel>;
    appList: Array<AppModel>;

    constructor(companyId) {
        super(companyId);
        this.profileList = [];
        this.appList = [];
    }
}


export class SignupSetupOutputModel extends SignupSetupModel {
    profile: ProfileModel;
    deviceEnrollDate: EnrollmentDateModel;
    readTnC: boolean;
    emailTnC: boolean;
    emmProductCode: string;
    version: string;

    constructor(companyId) {
        super(companyId);
        this.profile = new ProfileModel();
        this.deviceEnrollDate = new EnrollmentDateModel();
        this.readTnC = false;
        this.emailTnC = false;
        this.version = '';
    }
}


export class SettingsContent  {
    settingFields: Array<any>;

    constructor() {
        this.settingFields = [];
    }
}
